import { render, staticRenderFns } from "./StatisticLabelInfo.vue?vue&type=template&id=4b6aa484&scoped=true"
import script from "./StatisticLabelInfo.vue?vue&type=script&lang=js"
export * from "./StatisticLabelInfo.vue?vue&type=script&lang=js"
import style0 from "./StatisticLabelInfo.vue?vue&type=style&index=0&id=4b6aa484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6aa484",
  null
  
)

export default component.exports